import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card, Modal, Field, TextInput, TextArea, Select, StatusBadge } from "./adminShared";
import { formatDate } from "@/lib/format";
import { Plus, Trash2, Pencil } from "lucide-react";

const csv = (arr) => (arr || []).join(", ");
const fromCsv = (s) => (s || "").split(",").map((x) => x.trim()).filter(Boolean);

export default function Posts() {
  const [items, setItems] = useState(null);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/admin/posts").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const openNew = () => setEdit({ title: "", excerpt: "", body: "", categories: [], status: "draft" });
  const openEdit = async (p) => { const r = await api.get(`/admin/posts/${p.post_id}`); setEdit(r.data); };

  const save = async () => {
    try {
      if (edit.post_id) await api.put(`/admin/posts/${edit.post_id}`, edit);
      else await api.post("/admin/posts", edit);
      toast.success("Saved"); setEdit(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete this post?")) return; await api.delete(`/admin/posts/${id}`); toast.success("Deleted"); load(); };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl text-earth" style={{ fontWeight: 600 }}>Blog / Resources</h1>
        <button onClick={openNew} className="btn-gold text-sm" data-testid="new-post"><Plus size={16} className="mr-1" /> New post</button>
      </div>
      {!items ? <p className="text-earth/50">Loading…</p> : (
        <Card className="overflow-hidden">
          <div className="divide-y divide-hairline">
            {items.map((p) => (
              <div key={p.post_id} className="p-4 flex justify-between items-start gap-4">
                <div><div className="flex items-center gap-2"><StatusBadge status={p.status} /><span className="text-xs text-earth/40">{p.categories?.join(", ")}</span></div><h3 className="text-lg text-earth mt-1">{p.title}</h3><p className="text-xs text-earth/40">{p.publishedAt ? formatDate(p.publishedAt) : "Not published"}</p></div>
                <div className="flex gap-1">
                  <button onClick={() => openEdit(p)} className="p-2 text-earth/50 hover:text-earth" data-testid={`edit-post-${p.slug}`}><Pencil size={16} /></button>
                  <button onClick={() => del(p.post_id)} className="p-2 text-earth/50 hover:text-destructive"><Trash2 size={16} /></button>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}

      {edit && (
        <Modal title={edit.post_id ? "Edit post" : "New post"} onClose={() => setEdit(null)} wide>
          <Field label="Title"><TextInput value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} data-testid="post-title" /></Field>
          <Field label="Excerpt"><TextArea rows={2} value={edit.excerpt} onChange={(e) => setEdit({ ...edit, excerpt: e.target.value })} /></Field>
          <Field label="Categories (comma separated)"><TextInput value={csv(edit.categories)} onChange={(e) => setEdit({ ...edit, categories: fromCsv(e.target.value) })} /></Field>
          <Field label="Body (HTML supported)" hint="Use <p>, <h2>, <ul><li>, <blockquote> tags."><TextArea rows={10} value={edit.body} onChange={(e) => setEdit({ ...edit, body: e.target.value })} data-testid="post-body" /></Field>
          <Field label="Status"><Select value={edit.status} onChange={(e) => setEdit({ ...edit, status: e.target.value })} data-testid="post-status"><option value="draft">Draft</option><option value="published">Published</option></Select></Field>
          <button onClick={save} className="btn-gold w-full" data-testid="post-save">Save post</button>
        </Modal>
      )}
    </div>
  );
}
